// extracted by mini-css-extract-plugin
export default {"root":"DocumentDetailsLayout_root__WAqj3","main":"DocumentDetailsLayout_main__5OQzt"};